import useFetchFromBackend from "../../shared/lib/fetch-from-backed";

export default function usePoolList(queryParams = {}) {
  const { data, isLoading, error } = useFetchFromBackend({
    path: "/pool-list",
    params: queryParams,
    queryKey: ["poollist", queryParams],
    options: {
      staleTime: 60000,
      refetchOnWindowFocus: false,
    },
  });

  return { poolList: data , isPoolListLoading: isLoading, error };
}
